import { useTranslation } from "react-i18next";

import { Select } from "@/shared/components/organisms/Select";

const FormManualPayment = ({ handleChange, values, errors, touched }) => {
  const [t] = useTranslation();

  const optionsPayments = [
    { id: 1, name: t("direct_debit.views.payment_manual_1") },
    { id: 2, name: t("direct_debit.views.payment_manual_2") },
    { id: 3, name: t("direct_debit.views.payment_manual_3") },
    { id: 4, name: t("direct_debit.views.payment_manual_4") },
    { id: 5, name: t("direct_debit.views.payment_manual_5") },
  ];

  return (
    <div className="space-y-4 mt-5">
      <div>
        <Select
          name="manualPaymentMethod"
          tittle={t("direct_debit.views.payment_manual_message")}
          selected={optionsPayments.find(
            (type) => type.id == values.manualPaymentMethod
          )}
          setSelected={(select) => {
            handleChange("manualPaymentMethod", select.id);
          }}
          options={optionsPayments}
        />
        {errors.manualPaymentMethod && touched.manualPaymentMethod && (
          <div className="text-red-600 text-sm">
            {errors.manualPaymentMethod}
          </div>
        )}
      </div>
    </div>
  );
};

export default FormManualPayment;
